import * as React from "react";

import {translate} from "react-i18next";
import {t} from "i18next";
import {Icon} from "semantic-ui-react";

import Dialog from "../../../components/Dialogs/Dialog";
import Button from "../../../components/Button";
import {DtoListWithLinksOfOptionDto} from "../../../services/Client";

import DataAdapterOptionsView from "../DataAdapterOptionsView";

import {EStepTab, StepHeader} from "./MODUtils";
import {MODOverviewTable} from "./MODOverviewTable";
import {MODConfirmTab} from "./MODConfirmTab";

interface IWorkflowStatusMultiUpdateDialogProps {
    items: DataAdapterOptionsView[];
    multipleOptionDeletionResult?: number[];
    onSubmit: (options: DtoListWithLinksOfOptionDto) => void;
    onClose: () => void;
    onRefresh: () => void;
}

interface IWorkflowStatusMultiUpdateDialogState {
    activeTab: number;
    loaderActive: boolean;
    tablePage: number;
    selectedItemsOnPreviewScreen:number[];
}

class WorkflowStatusMultiUpdateDialog extends React.Component<
  IWorkflowStatusMultiUpdateDialogProps,
  IWorkflowStatusMultiUpdateDialogState
> {
  constructor(props: IWorkflowStatusMultiUpdateDialogProps) {
    super(props);

    this.state = {
      activeTab: EStepTab.OverviewTab,
      loaderActive: false,
      tablePage: 1,
      selectedItemsOnPreviewScreen: []
    };
  }

  componentDidMount(): void {
    this.setState({
        selectedItemsOnPreviewScreen:this.props.items.map(
            (item) => item.objectId
          ),
     });
  }
  componentDidUpdate(
    prevProps: Readonly<IWorkflowStatusMultiUpdateDialogProps>
  ): void {
    if (
      this.props.multipleOptionDeletionResult !== undefined &&
      prevProps.multipleOptionDeletionResult !==
        this.props.multipleOptionDeletionResult
    ) {
      this.setState({
        activeTab: EStepTab.ResultTab,
        loaderActive: false,
      });
    }
  }
 
  private onSubmit = () => {
    this.setState({ loaderActive: true, tablePage: 1 });
    const finalList = this.props.items.filter(
      (item) =>
        this.state.selectedItemsOnPreviewScreen.indexOf(item.objectId) !== -1
    );
    this.props.onSubmit({ list: finalList.map(item => item.dto)});
  }
  onRemove = (id: number, isSelected: boolean) => {
    const currentSelectedItemsOnPreviewScreen =
    this.state.selectedItemsOnPreviewScreen;
    if (isSelected) {
        if(currentSelectedItemsOnPreviewScreen.indexOf(id) === -1) {
            this.setState({
                selectedItemsOnPreviewScreen: [
                  ...currentSelectedItemsOnPreviewScreen,
                  id
                ],
              });
        }
    } else {
      this.setState({
        selectedItemsOnPreviewScreen:
          currentSelectedItemsOnPreviewScreen.filter((p) => p !== id),
      });
    }
  }

  render() {
    const dlgButton =
      this.state.activeTab === EStepTab.ResultTab ? (
        <Button
          key={"refreshButton"}
          icon={"refresh"}
          onClick={this.props.onRefresh}
          disabled={this.state.loaderActive}
        />
      ) : (
        <Button
          key={"cancelButton"}
          icon={"ban"}
          onClick={this.props.onClose}
          disabled={this.state.loaderActive}
        />
      );

    return (
      <Dialog
        open={true}
        title={t("PSL_MULTI_DLT:DIALOG_TITLE")}
        customStyleClassName={"multi-step-dialog"}
        actions={[dlgButton]}
      >
        <div style={{ marginBottom: "30px" }}>
          <StepHeader activeTab={this.state.activeTab} t={t} />
        </div>

        {/** First Tab */}
        {this.state.activeTab === EStepTab.OverviewTab && (
          <MODOverviewTable
            items={this.props.items}
            tablePage={this.state.tablePage}
            t={t}
            nextAction={() => this.setState({ activeTab: EStepTab.ConfirmTab })}
            onChangePage={(page: number) => this.setState({ tablePage: page })}
            isResultTab={false}
            onRemove={this.onRemove}
            selectedItemsOnPreviewScreen={
              this.state.selectedItemsOnPreviewScreen
            }
          />
        )}

        {/** Second Tab */}
        {this.state.activeTab === EStepTab.ConfirmTab &&
          this.state.selectedItemsOnPreviewScreen.length > 0 && (
            <MODConfirmTab
              loaderActive={this.state.loaderActive}
              numberOfOptions={this.state.selectedItemsOnPreviewScreen.length}
              t={t}
              onSubmit={this.onSubmit}
              backAction={() =>
                this.setState({ activeTab: this.state.activeTab - 1 })
              }
            />
          )}

        {/** Third Tab */}
        {this.state.activeTab === EStepTab.ResultTab &&
          this.props.multipleOptionDeletionResult !== undefined && (
            <>
              <p>
                <b>
                  {this.state.selectedItemsOnPreviewScreen.length -
                    this.props.multipleOptionDeletionResult.length}
                </b>
                {" " + t("PSL_MULTI_DLT:RESULT_SUCCESS")}
              </p>
              {this.props.multipleOptionDeletionResult.length > 0 && (
                <React.Fragment>
                  <div className={"display--flex"} style={{ marginBottom: 20 }}>
                    <Icon name="exclamation triangle" color="red" />
                    <p>
                      <b style={{ color: "red" }}>
                        {this.props.multipleOptionDeletionResult.length}
                      </b>
                      {" " + t("PSL_MULTI_DLT:RESULT_ERROR")}
                      {" " + t("PSL_MULTI_DLT:RESULT_ERROR_DISCLAIMER")}
                    </p>
                  </div>

                  <MODOverviewTable
                    items={this.props.items.filter((item) =>
                      // @ts-ignore already checked
                      this.props.multipleOptionDeletionResult.includes(
                        item.objectId
                      )
                    )}
                    tablePage={this.state.tablePage}
                    t={t}
                    onChangePage={(page: number) =>
                      this.setState({ tablePage: page })
                    }
                    isResultTab={true}
                    selectedItemsOnPreviewScreen={
                      this.state.selectedItemsOnPreviewScreen
                    }
                    onRemove={this.onRemove}
                  />
                </React.Fragment>
              )}
            </>
          )}
      </Dialog>
    );
  }
}

export default translate("PSL_MULTI_DLT")(WorkflowStatusMultiUpdateDialog);



// WEBPACK FOOTER //
// ./src/views/OptionsView/multipleOptionDeletionDialog/MultipleOptionDeletionDialog.tsx